import { milliseconds } from "date-fns";
import { makeHook } from "../../utils/makeSingleArgHook";
import { getFailedJobs, url } from "../requests/jobs/getFailedJobs";
function keyMaker(queryParams) {
    return [url(queryParams)];
}
const useFailedJobs = makeHook(getFailedJobs, keyMaker, {
    refetchInterval: milliseconds({ seconds: 10 }),
});
export default useFailedJobs;
//# sourceMappingURL=useFailedJobs.js.map